import { render, staticRenderFns } from "./OurWorkComponent5.vue?vue&type=template&id=7887582c&scoped=true&"
import script from "./OurWorkComponent5.vue?vue&type=script&lang=js&"
export * from "./OurWorkComponent5.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkComponent5.vue?vue&type=style&index=0&id=7887582c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887582c",
  null
  
)

export default component.exports